import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPtFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53770)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1393 41.3797H0.863573C0.387499 41.3797 0.00146484 40.9937 0.00146484 40.5176V9.4832C0.00146484 9.00713 0.387499 8.62109 0.863573 8.62109H49.1394C49.6154 8.62109 50.0015 9.00713 50.0015 9.4832V40.5176C50.0014 40.9938 49.6153 41.3797 49.1393 41.3797Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.1048 8.62109H0.863573C0.387499 8.62109 0.00146484 9.00703 0.00146484 9.4831V40.5175C0.00146484 40.9936 0.387499 41.3796 0.863573 41.3796H18.1049V8.62109H18.1048Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.1118 32.7519C22.3931 32.7519 25.8637 29.2813 25.8637 25C25.8637 20.7187 22.3931 17.248 18.1118 17.248C13.8305 17.248 10.3599 20.7187 10.3599 25C10.3599 29.2813 13.8305 32.7519 18.1118 32.7519Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6979 22.4136V25.8618C20.6979 27.2879 19.5378 28.448 18.1117 28.448C16.6856 28.448 15.5255 27.2879 15.5255 25.8618V22.4136H20.6979ZM21.5599 20.6895H14.6634C14.1873 20.6895 13.8013 21.0755 13.8013 21.5516V25.8619C13.8013 28.2424 15.7311 30.1722 18.1116 30.1722C20.4921 30.1722 22.422 28.2424 22.422 25.8619V21.5516C22.4221 21.0755 22.036 20.6895 21.5599 20.6895Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6978 22.4141V25.8623C20.6978 27.2884 19.5377 28.4485 18.1116 28.4485C16.6855 28.4485 15.5254 27.2884 15.5254 25.8623V22.4141H20.6978Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6547 21.9832C14.8928 21.9832 15.0857 21.7902 15.0857 21.5521C15.0857 21.3141 14.8928 21.1211 14.6547 21.1211C14.4166 21.1211 14.2236 21.3141 14.2236 21.5521C14.2236 21.7902 14.4166 21.9832 14.6547 21.9832Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.5507 21.9832C21.7887 21.9832 21.9817 21.7902 21.9817 21.5521C21.9817 21.3141 21.7887 21.1211 21.5507 21.1211C21.3126 21.1211 21.1196 21.3141 21.1196 21.5521C21.1196 21.7902 21.3126 21.9832 21.5507 21.9832Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6547 25.4314C14.8928 25.4314 15.0857 25.2385 15.0857 25.0004C15.0857 24.7623 14.8928 24.5693 14.6547 24.5693C14.4166 24.5693 14.2236 24.7623 14.2236 25.0004C14.2236 25.2385 14.4166 25.4314 14.6547 25.4314Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.5507 25.4314C21.7887 25.4314 21.9817 25.2385 21.9817 25.0004C21.9817 24.7623 21.7887 24.5693 21.5507 24.5693C21.3126 24.5693 21.1196 24.7623 21.1196 25.0004C21.1196 25.2385 21.3126 25.4314 21.5507 25.4314Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.1029 21.9832C18.341 21.9832 18.534 21.7902 18.534 21.5521C18.534 21.3141 18.341 21.1211 18.1029 21.1211C17.8649 21.1211 17.6719 21.3141 17.6719 21.5521C17.6719 21.7902 17.8649 21.9832 18.1029 21.9832Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6908 28.6102C20.9289 28.6102 21.1219 28.4172 21.1219 28.1791C21.1219 27.941 20.9289 27.748 20.6908 27.748C20.4528 27.748 20.2598 27.941 20.2598 28.1791C20.2598 28.4172 20.4528 28.6102 20.6908 28.6102Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5658 28.6102C15.8039 28.6102 15.9969 28.4172 15.9969 28.1791C15.9969 27.941 15.8039 27.748 15.5658 27.748C15.3278 27.748 15.1348 27.941 15.1348 28.1791C15.1348 28.4172 15.3278 28.6102 15.5658 28.6102Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.6669 24.7812V25.5236C18.6669 25.8307 18.4171 26.0805 18.1101 26.0805C17.803 26.0805 17.5532 25.8307 17.5532 25.5236V24.7812H18.6669Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.6669 23.0215V23.7639C18.6669 24.0709 18.4171 24.3207 18.1101 24.3207C17.803 24.3207 17.5532 24.0709 17.5532 23.7639V23.0215H18.6669Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.6669 26.5596V27.3019C18.6669 27.609 18.4171 27.8588 18.1101 27.8588C17.803 27.8588 17.5532 27.609 17.5532 27.3019V26.5596H18.6669Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1669 24.7812V25.5236C20.1669 25.8307 19.9171 26.0805 19.6101 26.0805C19.303 26.0805 19.0532 25.8307 19.0532 25.5236V24.7812H20.1669Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.1674 24.7812V25.5236C17.1674 25.8307 16.9176 26.0805 16.6105 26.0805C16.3035 26.0805 16.0537 25.8307 16.0537 25.5236V24.7812H17.1674Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53770",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPtFlag);
export { ForwardRef as ReactComponent };
